var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content" },
    [
      _c("div", { staticClass: "details-view" }, [
        _c("div", { staticStyle: { height: "100%" } }, [
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "flex-wrap": "nowrap",
                height: "100%"
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "section",
                  staticStyle: { width: "25%", "background-color": "#ffffff" }
                },
                [
                  _c("div", {}, [
                    _c(
                      "span",
                      {
                        staticStyle: {
                          position: "absolute",
                          top: "6px",
                          padding: "2px",
                          "background-color": "#169bd5",
                          cursor: "pointer",
                          color: "#169bd5"
                        }
                      },
                      [_vm._v(_vm._s("."))]
                    ),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "padding-left": "10px",
                          "padding-bottom": "15px"
                        }
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("CargoMsg.Cargo_TransmissionRule"))
                        )
                      ]
                    )
                  ]),
                  _c(
                    "div",
                    { staticStyle: { height: "50%" } },
                    [
                      _c(
                        "el-form",
                        {
                          staticStyle: { height: "100%" },
                          attrs: {
                            "label-position": "left",
                            "label-width": "0px"
                          }
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "input-from",
                              staticStyle: { height: "100%" },
                              attrs: { label: " " }
                            },
                            [
                              _c("el-input", {
                                staticClass: "input-border",
                                attrs: {
                                  "filter-chars": false,
                                  type: "textarea",
                                  readonly: true,
                                  clearable: ""
                                },
                                model: {
                                  value: _vm.ruleData,
                                  callback: function($$v) {
                                    _vm.ruleData = $$v
                                  },
                                  expression: "ruleData"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "padding-top": "5px",
                        "padding-bottom": "5px",
                        "justify-content": "space-between"
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "align-items": "center"
                          }
                        },
                        [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                position: "absolute",
                                padding: "2px",
                                "background-color": "#169bd5",
                                cursor: "pointer",
                                color: "#169bd5"
                              }
                            },
                            [_vm._v(_vm._s("."))]
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "padding-left": "10px",
                                display: "flex"
                              }
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("CargoMsg.Cargo_AccountPassword")
                                  ) +
                                  " "
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  ),
                  _c(
                    "div",
                    { staticStyle: { height: "50%", "margin-top": "12px" } },
                    [
                      _c(
                        "el-form",
                        {
                          staticStyle: { height: "100%" },
                          attrs: {
                            "label-position": "left",
                            "label-width": "100px"
                          }
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label:
                                  _vm.$t("CargoMsg.Cargo_AccountNumber") + ":"
                              }
                            },
                            [
                              _c("el-input", {
                                staticStyle: { width: "300px" },
                                attrs: { no: "accountId" },
                                model: {
                                  value: _vm.nbParams.accountId,
                                  callback: function($$v) {
                                    _vm.$set(_vm.nbParams, "accountId", $$v)
                                  },
                                  expression: "nbParams.accountId"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_Password") + ":"
                              }
                            },
                            [
                              _c("el-input", {
                                staticStyle: { width: "300px" },
                                attrs: { no: "passWord", type: "password" },
                                model: {
                                  value: _vm.nbParams.passWord,
                                  callback: function($$v) {
                                    _vm.$set(_vm.nbParams, "passWord", $$v)
                                  },
                                  expression: "nbParams.passWord"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "id:" } },
                            [
                              _c("el-input", {
                                staticStyle: { width: "300px" },
                                attrs: { no: "id" },
                                model: {
                                  value: _vm.nbParams.id,
                                  callback: function($$v) {
                                    _vm.$set(_vm.nbParams, "id", $$v)
                                  },
                                  expression: "nbParams.id"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label:
                                  _vm.$t("CargoMsg.Cargo_GetTokenUrl") + ":"
                              }
                            },
                            [
                              _c("el-input", {
                                staticStyle: { width: "300px" },
                                attrs: { no: "url" },
                                model: {
                                  value: _vm.nbParams.tokenUrl,
                                  callback: function($$v) {
                                    _vm.$set(_vm.nbParams, "tokenUrl", $$v)
                                  },
                                  expression: "nbParams.tokenUrl"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label:
                                  _vm.$t("CargoMsg.Cargo_InterfaceUrl") + ":"
                              }
                            },
                            [
                              _c("el-input", {
                                staticStyle: { width: "300px" },
                                attrs: { no: "taskName" },
                                model: {
                                  value: _vm.nbParams.interfaceUrl,
                                  callback: function($$v) {
                                    _vm.$set(_vm.nbParams, "interfaceUrl", $$v)
                                  },
                                  expression: "nbParams.interfaceUrl"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "action:" } },
                            [
                              _c("el-input", {
                                staticStyle: { width: "300px" },
                                attrs: { no: "action" },
                                model: {
                                  value: _vm.nbParams.action,
                                  callback: function($$v) {
                                    _vm.$set(_vm.nbParams, "action", $$v)
                                  },
                                  expression: "nbParams.action"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "section",
                  staticStyle: { width: "35%", "background-color": "#ffffff" }
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "space-between"
                      }
                    },
                    [
                      _c("div", [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              position: "absolute",
                              top: "6px",
                              padding: "2px",
                              "background-color": "#169bd5",
                              cursor: "pointer",
                              color: "#169bd5"
                            }
                          },
                          [_vm._v(_vm._s("."))]
                        ),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              "padding-left": "10px",
                              "padding-bottom": "5px"
                            }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("CargoMsg.Cargo_Script")) +
                                " "
                            )
                          ]
                        )
                      ]),
                      _c(
                        "div",
                        { staticStyle: { padding: "1px" } },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "success" },
                              on: { click: _vm.deBugHandler }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("CargoMsg.Cargo_DebuggingResults")
                                )
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ]
                  ),
                  _c(
                    "div",
                    { staticStyle: { display: "flex", height: "100%" } },
                    [
                      _c(
                        "div",
                        { staticStyle: { height: "100%", width: "100%" } },
                        [
                          _c(
                            "el-form",
                            {
                              staticStyle: { height: "100%" },
                              attrs: {
                                "label-position": "left",
                                "label-width": "0px"
                              }
                            },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "input-from",
                                  staticStyle: { height: "100%" },
                                  attrs: { label: " " }
                                },
                                [
                                  _c("el-input", {
                                    staticClass: "input-border",
                                    attrs: {
                                      "filter-chars": false,
                                      type: "textarea",
                                      clearable: ""
                                    },
                                    model: {
                                      value: _vm.nbParams.dataScript,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.nbParams,
                                          "dataScript",
                                          $$v
                                        )
                                      },
                                      expression: "nbParams.dataScript"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  )
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "section",
                  staticStyle: { width: "40%", "background-color": "#ffffff" }
                },
                [
                  _c("div", {}, [
                    _c(
                      "span",
                      {
                        staticStyle: {
                          position: "absolute",
                          top: "6px",
                          padding: "2px",
                          "background-color": "#169bd5",
                          cursor: "pointer",
                          color: "#169bd5"
                        }
                      },
                      [_vm._v(_vm._s("."))]
                    ),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "padding-left": "10px",
                          "padding-bottom": "15px"
                        }
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("CargoMsg.Cargo_TransmissionSample"))
                        )
                      ]
                    )
                  ]),
                  _c(
                    "div",
                    { staticStyle: { height: "100%" } },
                    [
                      _c(
                        "el-form",
                        {
                          staticStyle: { height: "100%" },
                          attrs: {
                            "label-position": "left",
                            "label-width": "0px"
                          }
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "input-from",
                              staticStyle: { height: "100%" },
                              attrs: { label: " " }
                            },
                            [
                              _c("el-input", {
                                staticClass: "input-border",
                                attrs: {
                                  disabled: !_vm.isPlatform,
                                  readonly: true,
                                  placeholder: _vm.contentTip,
                                  "filter-chars": false,
                                  type: "textarea",
                                  clearable: ""
                                },
                                model: {
                                  value: _vm.dataMessage,
                                  callback: function($$v) {
                                    _vm.dataMessage = $$v
                                  },
                                  expression: "dataMessage"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              )
            ]
          )
        ])
      ]),
      _vm.showMessage.visible
        ? _c("show-message-dialog", {
            attrs: {
              visible: _vm.showMessage.visible,
              "message-text": _vm.showMessage.messageText
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.showMessage, "visible", $event)
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }